export default "__VITE_ASSET__BRolnUlN__"